
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set } from 'lodash';
import { Tabs } from '../../components/tabs';
import { Grid } from '../../components/table';
import { CONFIG } from '../../../config'
import axios from 'axios';
import { ToolBar } from '../../components/toolbar';
import { Modal } from '../../components/modal';
import { FormA } from '../../components/form';
import moment from 'moment';
import { getFormState } from '../../../helpers/form';
import dayjs from 'dayjs';
const API_HOST = CONFIG.modules['accounts'].host
const { Manager } = require("socket.io-client");



const items = {
    'Approve Leaves': {
        name: 'Approve Leaves',
        view: ''
    },

}


export const LeaveActions = (props) => {
    let socket
    const { roles, user, users, Designations, Departments, Languages, Districts } = useSelector((state) => (state.user || {}))
    const userStore = useSelector((state) => (state.user || {}))

    const [active, setActive] = useState('Approve Leaves')
    const [data, setData] = useState(users || [])
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('new')
    const [saved, setSaved] = useState(null);
    const [index, setIndex] = useState(null);
    const [openConfirm, setOpenConfirm] = useState(false)
    const [filter, setFilter] = useState({
        date: dayjs()
    })

    const fetchLeaves = () => {
        axios.get(API_HOST + '/leaves-for-approval?date=' + encodeURIComponent(dayjs(filter.date).format('YYYY-MM-DD'))).then((resp) => {
            if (resp.data && resp.data.success) {
                setData(resp.data.data.map((u) => {
                    u.name = u.user.name
                    return u
                }))
            }
        }).catch((e) => {
            console.log(e)
        })
    }


    useEffect(() => {
        fetchLeaves()
    }, [active])

    useEffect(() => {
        fetchLeaves()
    }, [filter.date])

    useEffect(()=>{
        if (user) {
            const manager = new Manager(CONFIG.modules['accounts'].socket, {
                reconnectionDelayMax: 10000,
                path: "/accounts"
            });

            socket = manager.socket("/common", {
                query: {
                    token: localStorage.getItem('authToken') || ''
                }
            });

            socket.on(`${user._id}-poc-leave-updated`, ({data}) => {
                if (data) {
                    fetchLeaves()
                    console.log(data)
                }

            })

            socket.on(`${user._id}-rm-leave-updated`, ({data}) => {
                if (data) {
                    fetchLeaves()
                    console.log(data)
                }

            })

        }
    },[user])

    useEffect(() => {
        return () => {
            if (socket) {
                socket.removeAllListeners();
            }
        }
    }, [])





    const handleEdit = (id, status) => {

        axios.put(API_HOST + `/leave/${data[id]._id}`, {
            status
        }).then((resp) => {
            if (resp.data && resp.data.success) {
                data[id] = resp.data.data
                setData([...data])
            }
        }).catch((e) => {
            console.log(e)
        })
    }


    return (
        <>
            <Tabs items={items} active={active} onChange={(key) => {
                setActive(key)
            }} />
            <ToolBar name={active} buttons={[
            ]} filters={[
                {
                    field: {
                        name: 'date',
                        type: 'date',
                        label: '',
                    },
                    onChange: (name, value) => {
                        filter[name] = value
                        setFilter({ ...filter })
                    },
                    state: filter

                }
            ]} />
            <Box sx={{ mt: 2 }}>
                <Grid data={data} columns={[
                    {
                        id: 'createdAt', label: 'Date', minWidth: 60, format: (data, row) => {
                            return data ? dayjs(data).format('DD-MM-YYYY HH:mm:ss') : ''
                        }
                    },
                    {
                        id: 'user', label: 'User', minWidth: 120, format: (data, row) => {
                            return data ? data.name || '' : ''
                        }
                    },
                    { id: 'leaveType', label: 'Type ', minWidth: 120, format: (data, row) => {
                        return data?data=='full'?'Full day':data=='half'?'Half day':'Shift swapping':''
                    } },

                    // { id: 'type', label: 'Type ', minWidth: 120 },
                    { id: 'description', label: 'Description', minWidth: 170 },
                    { id: '_id', label: 'Details', minWidth: 170, format: (data, row) => {
                        switch(row.leaveType) {
                            case 'shift':
                                return <Box>
                            
                            <Typography sx={{fontSize: '.9em'}}>For date: {dayjs(row.forDate).format('DD-MM-YYYY')}</Typography>
                            {/* <Typography sx={{fontSize: '.9em'}}>Shift: {`${shiftMap[u.currentShift.shift]?.name} (${dayjs(shiftMap[u.currentShift.shift]?.start).format('hh:mm a')} - ${dayjs(shiftMap[u.currentShift.shift]?.end).format('hh:mm a')})
                        
                        (${dayjs(u.currentShift.from).format('DD/MM/YYYY')} - ${dayjs(u.currentShift.to).format('DD/MM/YYYY')})`}</Typography> */}

                        </Box>
                                break;
                            case 'half': 
                            return <Box>
                            
                            <Typography sx={{fontSize: '.9em'}}>For date: {dayjs(row.forDate).format('DD-MM-YYYY')}</Typography>
                        </Box>
                        break;
                            default:
                                return <Box>
                            
                            <Typography sx={{fontSize: '.9em'}}> ({dayjs(row.from).format('DD-MM-YYYY')} - {dayjs(row.to).format('DD-MM-YYYY')})</Typography>
                            {/* <Typography> {dayjs(row.forDate).format('DD-MM-YYYY')}</Typography> */}

                        </Box>
                                break;
                        }
                        
                    } },

                    // {
                    //     id: 'from', label: 'From', minWidth: 60, format: (data, row) => {
                    //         return data ? dayjs(data).format('DD-MM-YYYY') : ''
                    //     }
                    // },
                    // {
                    //     id: 'to', label: 'To', minWidth: 60, format: (data, row) => {
                    //         return data ? dayjs(data).format('DD-MM-YYYY') : ''
                    //     }
                    // },
                    {
                        id: 'user', label: 'Role', minWidth: 60, format: (data, row) => {
                            if (!data) return ''
                            if (data.pocForLeaves === user._id)
                                return 'POC'
                            if (data.reportingManager === user._id)
                                return 'RM'
                            return ''
                        }
                    },

                    { id: 'approved', label: 'Status', minWidth: 80 },
                    // {
                    //     id: '_id', label: 'Action', minWidth: 100, format: (data, row) => {

                    //         if(row.leaveType == 'half') {
                    //             return ''
                    //         } else {
                    //             if(['Pending'].includes(row.approved)) {
                    //                 return <Button variant="outlined" size="small">Forward</Button>
                    //             } if(['Forwarded'].includes(row.approved)) {
                    //                 return <Button variant="outlined" size="small">Approve</Button>

                    //             }
                    //             if(['Approved', 'Pending', 'Forwarded'].includes(row.approved)) {
                    //                 return <Button variant="outlined" size="small">Cancel</Button>

                    //             }
                    //         }
                    //     }
                    // },

                ]}
                    actions={[
                        // {
                        //     name: 'Forward',
                        //     value: 'Approved',
                        //     showIf: {
                        //         key: 'approved',
                        //         values: ['Pending']
                        //     },
                        //     showFunction: (data) => {
                        //         return data.user.pocForLeaves == user._id && data.leaveType !='shift'
                        //     },
                        //     onClick: (id) => {
                        //         handleEdit(id, 'Forwarded')
                        //     }
                        // },
                        {
                            name: 'Approve',
                            value: 'Approved',
                            showIf: {
                                key: 'approved',
                                values: ['Forwarded', 'Pending']
                            },
                            showFunction: (data) => {
                                return data.user.reportingManager == user._id  && data.leaveType !='shift'
                            },
                            onClick: (id) => {
                                handleEdit(id, 'Approved')
                            }
                        },
                        {
                            name: 'Cancel',
                            value: 'Rejected',
                            showIf: {
                                key: 'approved',
                                values: ['Approved', 'Pending', 'Forwarded']
                            },
                            showFunction: (data) => {
                                if(data.leaveType =='shift') {
                                    return false
                                }
                                // if (['Approved', 'Forwarded'].includes(data.approved) && data.user.reportingManager == user._id)
                                //     return true;
                                if (['Pending', 'Forwarded'].includes(data.approved) && data.user.pocForLeaves == user._id)
                                    return true
                                return false;
                            },
                            onClick: (id) => {
                                handleEdit(id, 'Rejected')
                            }
                        }
                    ]}

                ></Grid>
            </Box>
            {/* <Modal open={open}
                handleClose={() => { setOpen(false) }}
                head={`${action == 'new' ? 'Add' : 'Edit'} ${active}`}
                buttons={[
                    {
                        name: 'Cancel',
                        onClick: () => {
                            setOpen(false)
                        }
                    },
                    {
                        name: action == 'new' ? 'Create' : 'Save',
                        onClick: () => {
                            switch (action) {
                                case 'new':
                                    handleSubmit()
                                    break;
                                case 'edit':
                                    handleEdit()
                                    break;
                                default: break;
                            }
                        }
                    }
                ]}

            >
                 {
                    action == 'edit' &&
                    <Typography variant='p' color="grey">{
                        'ID: ' + saved._id
                    }</Typography>
                }
                {
                    Array.isArray(fields) &&
                    <FormA fields={fields}
                        data={{ roles, Designations, Districts, Languages, Departments, users }}
                        onChange={(name, value, multiple) => {
                            formData[name] = value
                            setFormData({ ...formData })
                        }}
                        state={formData||{}}
                    />
                }
               

            </Modal>

            <Modal open={openConfirm}
                handleClose={() => { setOpen(false) }}
                head={`${'Delete'} ${active}`}
                desc={`Please confirm to delete the following ${active}?`}
                buttons={[
                    {
                        name: 'Cancel',
                        onClick: () => {
                            setOpenConfirm(false)
                        }
                    },
                    {
                        name: 'Delete',
                        onClick: () => {
                            handleDelete()
                        }
                    }
                ]}

            >
                {
                    saved &&
                    <Box>
                        <Typography variant='p' color="grey">{'ID: ' + saved._id}</Typography><br></br>
                        <Typography variant='p' color="grey">{'Name: ' + saved.name}</Typography>
                    </Box>
                }

            </Modal> */}
        </>
    )
}